import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';
import logo from '../Images/logo.jpeg';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [galleryOpen, setGalleryOpen] = useState(false);

  return (
    <>
      {/* Top Bar */}
      <header className="top-bar">
        <div className="top-bar__logo">
          <div className="logo-icon">
            <img src={logo} alt="Logo" />
          </div>
          <div className="logo-text">
            <span className="logo-main">Little Flowers' School</span>
            <span className="logo-sub">Affiliated to CBSE</span>
          </div>
        </div>
        <div className="top-bar__actions">
          <Link to="/teacherspanel" className="btn btn--primary">Panel</Link>
          <Link to="/admission" className="btn btn--primary">Admission</Link>
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span><span></span><span></span>
          </button>
        </div>
      </header>

      {/* Nav Bar */}
      <nav className="main-nav">
        <ul className="nav-links">

          <li>
            <NavLink to="/" end className={({ isActive }) => isActive ? 'active-link' : ''}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" end className={({ isActive }) => isActive ? 'active-link' : ''}>
             About us
            </NavLink>
          </li>
          <li>
            <NavLink to="/assignments" end className={({ isActive }) => isActive ? 'active-link' : ''}>
             Assignments
            </NavLink>
          </li>
          <li>
            <NavLink to="/Gallery" end className={({ isActive }) => isActive ? 'active-link' : ''}>
             Gallery
            </NavLink>
          </li>
          <li>
            <NavLink to="/News" end className={({ isActive }) => isActive ? 'active-link' : ''}>
             News & Events
            </NavLink>
          </li>
          <li>
            <NavLink to="/Mandetorydisclosure" end className={({ isActive }) => isActive ? 'active-link' : ''}>
             Mandetory Disclosure
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" end className={({ isActive }) => isActive ? 'active-link' : ''}>
                Contact us
             </NavLink>
          </li>
          <li>
            <NavLink to="/Adminpanel" end className={({ isActive }) => isActive ? 'active-link' : ''}>
             Admin Panel
            </NavLink>
          </li>
          
        </ul>
        <div className="nav-location">
          <span className="pin">📍</span> Odisha
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="mobile-menu">
          <button className="mobile-menu__close" onClick={() => setMenuOpen(false)}>✕</button>
          <ul>
            <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
            <li><Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link></li>
            <li><Link to="/assignments" onClick={() => setMenuOpen(false)}>Academics</Link></li>
            <li><Link to="/Gallery" onClick={() => setMenuOpen(false)}>Gallery</Link></li>
            <li><Link to="/Mandetorydisclosure" onClick={() => setMenuOpen(false)}>Mandetory Disclousure</Link></li>
            <li><Link to="/news" onClick={() => setMenuOpen(false)}>News &amp; Events</Link></li>
            <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</Link></li>
          </ul>
          <div className="mobile-menu__quick">
            Quick Links: <Link to="/jobs">Jobs</Link> | <Link to="/parent-portal">Parent Portal</Link>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;